import { mapKeys } from "lodash-es";

export default {
  applyToVersions: "<2.6.0",
  type: "before",
  name: "transfer elementresources to relations",
  migrate(data) {
    if (!data.elementResources) {
      return data;
    }
    if (!data.relations) {
      return data;
    }
    if (!data.resources) {
      return data;
    }

    // Move all element-resources over to relations store
    const relationStoreState = data.relations;
    let relationCount = relationStoreState.count;

    for (const id in data.elementResources.items) {
      const elRes = data.elementResources.items[id];
      const resource = data.resources.items[elRes.endItemId];
      elRes.type = "relation";
      elRes.description = resource?.docs?.[`element_${elRes.id}`] ?? "";
      elRes.id = relationCount;

      relationStoreState.items[relationCount] = elRes;
      relationCount++;

      delete data.elementResources.items[id];
    }
    relationStoreState.count = relationCount;

    // update relation draft keys
    const relationDrafts = data.relations.relationDrafts;
    mapKeys(relationDrafts, (draft, key) => {
      if (key.startsWith("element") | key.startsWith("resource")) return key;
      const ids = key.split("-");
      return `element.${ids[0]}-element.${ids[1]}`;
    });

    return data;
  }
};
